// src/shadowGrove/world/terminology.js

export const LIBERI_TERMS = {
    child: "Scholar",
    children: "Scholars",

    parent: "Guide",
    teacher: "Magister",

    classroom: "Schola",
    calendar: "Calendar",
    assignment: "Quest",
    assignments: "Quests",

    rewardShop: "Taberna Vastae",
    companion: "Genius",
    companions: "Genii",

    dashboard: "Atrium",
    library: "Bibliotheca",
    archive: "Codex",

    progress: "Growth",
    achievement: "Laurel",
    achievements: "Laurels",
};